// removed by extract-text-webpack-plugin
module.exports = {"heart":"heart__35S46"};


//////////////////
// WEBPACK FOOTER
// ./components/SVGs/style.css
// module id = eP7G
// module chunks = 0